var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableDesc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 126,
    viewBox: "0 0 187 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 182.222,
    y: 113.679,
    width: 175.003,
    height: 84.8212,
    transform: "rotate(-180 182.222 113.679)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 172.781,
    y: 122.466,
    width: 159.091,
    height: 14.088,
    transform: "rotate(-180 172.781 122.466)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175.663,
    y: 121.096,
    width: 7.80649,
    height: 14.088,
    transform: "rotate(-180 175.663 121.096)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 177.902,
    y: 116.713,
    width: 7.80649,
    height: 14.088,
    transform: "rotate(-180 177.902 116.713)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 179.865,
    y: 41.2578,
    width: 7.80649,
    height: 14.088,
    transform: "rotate(-180 179.865 41.2578)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 153.709,
    y: 24.2981,
    width: 7.80649,
    height: 18.7314,
    transform: "rotate(-180 153.709 24.2981)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 148.477,
    y: 28.603,
    width: 7.80649,
    height: 18.7314,
    transform: "rotate(-180 148.477 28.603)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 143.96,
    y: 36.5354,
    width: 7.80649,
    height: 18.7314,
    transform: "rotate(-180 143.96 36.5354)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0715,
    y: 116.791,
    width: 6.65493,
    height: 14.088,
    transform: "rotate(-180 16.0715 116.791)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5576,
    y: 38.3228,
    width: 6.65493,
    height: 14.088,
    transform: "rotate(-180 17.5576 38.3228)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 174.789,
    y: 35.5835,
    width: 160.037,
    height: 14.088,
    transform: "rotate(-180 174.789 35.5835)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.352 22.0039L155.673 22.0039L155.673 4.70586L151.352 4.70586L151.352 22.0039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.032 4.70581L151.353 4.70581L151.353 0.400866L147.032 0.400865L147.032 4.70581Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.633 9.08911L146.954 9.08911L146.954 4.78417L142.633 4.78417L142.633 9.08911Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.313 13.394L142.634 13.394L142.634 9.0891L138.313 9.0891L138.313 13.394Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.993 17.699L138.314 17.699L138.314 13.394L133.993 13.394L133.993 17.699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.594 22.0039L133.915 22.0039L133.915 17.699L129.594 17.699L129.594 22.0039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9379 22.0039L133.915 22.0039L133.915 17.699L15.9379 17.699L15.9379 22.0039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.353 22.0039L171.147 22.0039L171.147 17.699L151.353 17.699L151.353 22.0039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.328 124.618L171.147 124.618L171.147 120.313L15.328 120.313L15.328 124.618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.542252 111.304L4.86328 111.304L4.86329 30.3715L0.542259 30.3715L0.542252 111.304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26125 119.993L13.5823 119.993L13.5823 115.688L9.26125 115.688L9.26125 119.993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94118 115.609L9.26221 115.609L9.26221 111.304L4.94118 111.304L4.94118 115.609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26125 26.0664L13.5823 26.0664L13.5823 21.7615L9.26125 21.7615L9.26125 26.0664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94118 30.3713L9.26221 30.3713L9.26221 26.0664L4.94118 26.0664L4.94118 30.3713Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.865 111.625L184.186 111.625L184.186 30.692L179.865 30.692L179.865 111.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.146 120.313L175.467 120.313L175.467 116.008L171.146 116.008L171.146 120.313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.544 115.93L179.865 115.93L179.865 111.625L175.544 111.625L175.544 115.93Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.146 26.387L175.467 26.387L175.467 22.082L171.146 22.082L171.146 26.387Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.544 30.6919L179.865 30.6919L179.865 26.3869L175.544 26.3869L175.544 30.6919Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.709 22.7866L158.03 22.7866L158.03 5.48857L153.709 5.48857L153.709 22.7866Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.388 5.48877L153.709 5.48877L153.709 1.18382L149.388 1.18382L149.388 5.48877Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.99 9.87183L149.311 9.87183L149.311 5.56688L144.99 5.56688L144.99 9.87183Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.669 14.1768L144.99 14.1768L144.99 9.87181L140.669 9.87181L140.669 14.1768Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.349 18.4817L140.67 18.4817L140.67 14.1767L136.349 14.1767L136.349 18.4817Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.951 22.7866L136.272 22.7866L136.272 18.4817L131.951 18.4817L131.951 22.7866Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9379 22.7866L136.272 22.7866L136.272 18.4817L15.9379 18.4817L15.9379 22.7866Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.709 22.7866L173.503 22.7866L173.503 18.4817L153.709 18.4817L153.709 22.7866Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.328 125.401L173.503 125.401L173.503 121.096L15.328 121.096L15.328 125.401Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8987 112.087L7.21973 112.087L7.21973 31.1542L2.8987 31.1542L2.8987 112.087Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6177 120.775L15.9387 120.775L15.9387 116.47L11.6177 116.47L11.6177 120.775Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29762 116.392L11.6187 116.392L11.6187 112.087L7.29762 112.087L7.29762 116.392Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6177 26.8491L15.9387 26.8491L15.9387 22.5442L11.6177 22.5442L11.6177 26.8491Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29762 31.1541L11.6187 31.1541L11.6187 26.8491L7.29762 26.8491L7.29762 31.1541Z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M182.221 112.408L186.542 112.408L186.542 31.4747L182.221 31.4747L182.221 112.408Z",
    fill: "#231F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M173.502 121.096L177.823 121.096L177.823 116.791L173.502 116.791L173.502 121.096Z",
    fill: "#231F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M177.901 116.713L182.222 116.713L182.222 112.408L177.901 112.408L177.901 116.713Z",
    fill: "#231F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M173.502 27.1697L177.823 27.1697L177.823 22.8647L173.502 22.8647L173.502 27.1697Z",
    fill: "#231F20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.901 31.4746L182.222 31.4746L182.222 27.1697L177.901 27.1697L177.901 31.4746Z",
    fill: "#231F20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8697 56.2791V42.9457H25.4253V40.7235H38.7586V42.9457H34.3142V56.2791H29.8697ZM45.4166 54.0568H49.8611V47.3902H45.4166V54.0568ZM43.1944 54.0568H40.9722V47.3902H43.1944V45.1679H54.3055V56.2791H43.1944V54.0568ZM58.7413 54.0568H56.519V42.9457H58.7413V40.7235H67.6302V42.9457H60.9635V47.3902H67.6302V49.6124H69.8524V54.0568H67.6302V56.2791H58.7413V54.0568ZM65.4079 54.0568V49.6124H60.9635V54.0568H65.4079ZM72.0659 56.2791V54.0568H74.2881V45.1679H85.3993V56.2791H80.9548V47.3902H78.7326V54.0568H76.5104V56.2791H72.0659ZM92.0572 54.0568V56.2791H87.6128V45.1679H92.0572V49.6124H94.2795V47.3902H96.5017V45.1679H100.946V56.2791H96.5017V51.8346H94.2795V54.0568H92.0572ZM103.16 56.2791V45.1679H107.604V54.0568H112.049V45.1679H116.493V58.5013H112.049V56.2791H103.16ZM123.151 54.0568H127.595V47.3902H123.151V54.0568ZM120.929 54.0568H118.707V47.3902H120.929V45.1679H132.04V56.2791H120.929V54.0568Z",
    fill: "#444042"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9957 76.0664H27.329V74.5108H31.9957V76.0664ZM27.329 82.2886V85.3997H25.7734V76.0664H27.329V80.733H31.9957V82.2886H27.329ZM33.5512 80.733H31.9957V76.0664H33.5512V80.733ZM36.6669 80.733H35.1113V76.0664H36.6669V80.733ZM41.3336 77.6219H39.778V76.0664H41.3336V74.5108H42.8891V82.2886H41.3336V80.733H39.778V79.1775H41.3336V77.6219ZM39.778 82.2886H36.6669V80.733H39.778V82.2886ZM39.778 76.0664H36.6669V74.5108H39.778V76.0664ZM52.227 80.733H50.6714V77.6219H52.227V80.733ZM50.6714 72.9552H46.0048V71.3997H50.6714V72.9552ZM46.0048 77.6219H47.5603V79.1775H46.0048V80.733H44.4492V72.9552H46.0048V77.6219ZM50.6714 82.2886H46.0048V80.733H50.6714V82.2886ZM50.6714 77.6219H47.5603V76.0664H50.6714V77.6219ZM55.3427 80.733H53.7871V76.0664H55.3427V80.733ZM60.0093 76.0664H55.3427V74.5108H60.0093V76.0664ZM61.5649 80.733H60.0093V76.0664H61.5649V80.733ZM60.0093 82.2886H55.3427V80.733H60.0093V82.2886ZM67.7917 76.0664V82.2886H66.2361V76.0664H63.125V74.5108H70.9028V76.0664H67.7917ZM74.0184 80.733H72.4629V76.0664H74.0184V80.733ZM78.6851 77.6219H77.1296V76.0664H78.6851V74.5108H80.2407V82.2886H78.6851V80.733H77.1296V79.1775H78.6851V77.6219ZM77.1296 82.2886H74.0184V80.733H77.1296V82.2886ZM77.1296 76.0664H74.0184V74.5108H77.1296V76.0664ZM88.0184 80.733H86.4629V76.0664H88.0184V80.733ZM94.2407 76.0664H88.0184V74.5108H94.2407V76.0664ZM94.2407 82.2886H88.0184V80.733H94.2407V82.2886ZM108.241 80.733H106.685V77.6219H108.241V80.733ZM106.685 72.9552H102.018V71.3997H106.685V72.9552ZM102.018 77.6219H103.574V79.1775H102.018V80.733H100.463V72.9552H102.018V77.6219ZM106.685 82.2886H102.018V80.733H106.685V82.2886ZM106.685 77.6219H103.574V76.0664H106.685V77.6219ZM111.356 80.733H109.801V76.0664H111.356V80.733ZM116.023 77.6219H114.467V76.0664H116.023V74.5108H117.579V82.2886H116.023V80.733H114.467V79.1775H116.023V77.6219ZM114.467 82.2886H111.356V80.733H114.467V82.2886ZM114.467 76.0664H111.356V74.5108H114.467V76.0664ZM120.694 77.6219H119.139V76.0664H120.694V77.6219ZM125.361 76.0664H120.694V74.5108H125.361V76.0664ZM125.361 82.2886H120.694V80.733H125.361V82.2886ZM120.694 80.733H119.139V79.1775H120.694V80.733ZM125.361 79.1775H123.805V77.6219H125.361V79.1775ZM126.916 77.6219H125.361V76.0664H126.916V77.6219ZM126.916 80.733H125.361V79.1775H126.916V80.733ZM130.032 80.733H128.477V76.0664H130.032V80.733ZM134.699 77.6219H133.143V76.0664H134.699V74.5108H136.254V82.2886H134.699V80.733H133.143V79.1775H134.699V77.6219ZM133.143 82.2886H130.032V80.733H133.143V82.2886ZM133.143 76.0664H130.032V74.5108H133.143V76.0664ZM142.481 80.733H140.926V77.6219H142.481V80.733ZM144.037 76.0664V74.5108H145.592V82.2886H144.037V77.6219H142.481V76.0664H144.037ZM139.37 77.6219V82.2886H137.814V74.5108H139.37V76.0664H140.926V77.6219H139.37ZM148.708 80.733V82.2886H147.152V74.5108H148.708V79.1775H150.263V80.733H148.708ZM153.375 76.0664V74.5108H154.93V82.2886H153.375V77.6219H151.819V76.0664H153.375ZM151.819 79.1775H150.263V77.6219H151.819V79.1775ZM27.329 99.2886V100.844H25.7734V97.733H27.329V93.0664H28.8845V97.733H31.9957V93.0664H33.5512V97.733H35.1068V100.844H33.5512V99.2886H27.329ZM31.9957 93.0664H28.8845V91.5108H31.9957V93.0664ZM38.2118 97.733H36.6562V93.0664H38.2118V97.733ZM42.8785 94.6219H41.3229V93.0664H42.8785V91.5108H44.434V99.2886H42.8785V97.733H41.3229V96.1775H42.8785V94.6219ZM41.3229 99.2886H38.2118V97.733H41.3229V99.2886ZM41.3229 93.0664H38.2118V91.5108H41.3229V93.0664ZM47.5497 96.1775V99.2886H45.9941V91.5108H47.5497V94.6219H52.2164V91.5108H53.7719V99.2886H52.2164V96.1775H47.5497ZM56.8876 96.1775V99.2886H55.332V91.5108H56.8876V94.6219H61.5543V91.5108H63.1098V99.2886H61.5543V96.1775H56.8876ZM69.3366 97.733H67.781V96.1775H69.3366V97.733ZM72.4477 99.2886H70.8921V91.5108H72.4477V99.2886ZM66.2255 94.6219H67.781V96.1775H66.2255V97.733H67.781V99.2886H64.6699V91.5108H66.2255V94.6219ZM75.5634 99.2886H74.0078V97.733H75.5634V99.2886ZM77.1189 97.733H75.5634V96.1775H77.1189V97.733ZM78.6745 96.1775H77.1189V94.6219H78.6745V96.1775ZM75.5634 93.0664H74.0078V91.5108H75.5634V93.0664ZM77.1189 94.6219H75.5634V93.0664H77.1189V94.6219ZM80.23 97.733H78.6745V96.1775H80.23V97.733ZM81.7856 99.2886H80.23V97.733H81.7856V99.2886ZM80.23 94.6219H78.6745V93.0664H80.23V94.6219ZM81.7856 93.0664H80.23V91.5108H81.7856V93.0664ZM95.7856 97.733H94.23V96.1775H95.7856V97.733ZM94.23 91.5108V93.0664H89.5634V94.6219H94.23V96.1775H89.5634V97.733H94.23V99.2886H88.0078V91.5108H94.23ZM95.7856 94.6219H94.23V93.0664H95.7856V94.6219ZM103.563 97.733H109.786V99.2886H102.008V88.3997H109.786V89.9552H103.563V93.0664H108.23V94.6219H103.563V97.733ZM112.901 99.2886H111.346V97.733H112.901V99.2886ZM114.457 97.733H112.901V96.1775H114.457V97.733ZM116.012 96.1775H114.457V94.6219H116.012V96.1775ZM112.901 93.0664H111.346V91.5108H112.901V93.0664ZM114.457 94.6219H112.901V93.0664H114.457V94.6219ZM117.568 97.733H116.012V96.1775H117.568V97.733ZM119.123 99.2886H117.568V97.733H119.123V99.2886ZM117.568 94.6219H116.012V93.0664H117.568V94.6219ZM119.123 93.0664H117.568V91.5108H119.123V93.0664ZM122.239 97.733H120.684V93.0664H122.239V97.733ZM128.461 93.0664H122.239V91.5108H128.461V93.0664ZM128.461 99.2886H122.239V97.733H128.461V99.2886ZM136.244 93.0664H131.577V91.5108H136.244V93.0664ZM131.577 96.1775V97.733H130.021V93.0664H131.577V94.6219H136.244V93.0664H137.799V96.1775H131.577ZM137.799 99.2886H131.577V97.733H137.799V99.2886ZM140.915 99.2886H139.359V88.3997H140.915V99.2886Z",
    fill: "#1B1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDesc);
export default __webpack_public_path__ + "static/media/tableDesc.41790acf197826975fbc745320217161.svg";
export { ForwardRef as ReactComponent };